export const Wip = ({ title }) => {
  return (
    <div class="site-width">
      <div class="header-wrapper mb-2 mb-md-3">
        <div class="container-fluid">
          <h1 class="pb-0 mt-1 mt-md-2 mb-1 mb-md-2">Déclaration d'accessibilité : {title}</h1>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-10 col-xl-8">
            <div class="alert-container alert-info mb-2" role="alert">
              <p class="alert">
                <span class="alert-icon icon-info" aria-hidden="true"></span>
                <span class="text-mw">Ce site est en cours de refonte, nous publierons la déclaration associée dès que possible.</span>
              </p>
              <div class="alert-content">
                <p class="alert-text">
                  Vous pouvez nous aider à améliorer l'accessibilité du site en nous signalant les problèmes éventuels que vous rencontrez. Pour ce faire,{' '}
                  <a href="mailto:accessibilite.france@orange.com">envoyez-nous un courriel à accessibilite.france@orange.com</a>.
                </p>
              </div>
            </div>
            <p>
              Vous pouvez vous informer sur le{' '}
              <a
                href="https://oran.ge/accessibilite-schema"
                target="_blank"
                title="schéma pluriannuel d'amélioration de l'accessibilité numérique (nouvelle fenêtre : PDF, 230Ko)"
                aria-label="schéma pluriannuel d'amélioration de l'accessibilité numérique (nouvelle fenêtre : PDF, 230Ko)"
              >
                schéma pluriannuel d'amélioration de l'accessibilité numérique (nouvelle fenêtre : PDF, 230Ko)
              </a>{' '}
              sur lequel s'engage Orange.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
